'use client'
import { useEffect, useState } from "react"
import Navbar from "../components/navbar"
import Image from "next/image"
import { motion } from "framer-motion"
import { Metadata } from "next"

export const metadata: Metadata = {
  title: 'Gyno Club | Kadınlara Özel Ayrıcalıklar Dünyası',
  description: 'Gyno Club, kadınların alışverişten yeme içmeye, sağlıktan sosyal yaşama kadar tüm ihtiyaçlarında ayrıcalık sağlayan premium bir yaşam kulübüdür.',
  keywords: ['kadın', 'ayrıcalık', 'indirim', 'alışveriş', 'gyno club', 'mobil uygulama', 'sosyal yaşam'],
  openGraph: {
    title: 'Gyno Club | Ayrıcalıklar Dünyası',
    description: 'Sadece size özel deneyimler ve fırsatlarla dolu yeni nesil yaşam kulübü.',
    url: 'https://gynoclub.com.tr',
    siteName: 'Gyno Club',
    locale: 'tr_TR',
    type: 'website',
  },
};

interface Brand {
  brandLogo: {
    filename_disk: string
    title: string
  }
}

export default function Page() {
  const [brands, setBrands] = useState<Brand[]>([])

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await fetch(
          'https://api.gynoclub.com.tr/items/brandList?fields=brandLogo.filename_disk,brandLogo.title'
        )
        const json = await res.json()
        if (json?.data) setBrands(json.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchBrands()
  }, [])

  return (
    <main className="w-full min-h-screen bg-[#FAFAFA]">
      <Navbar />

      <section className="relative pt-36 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-purple-400/20 rounded-full blur-[120px]" />
          <div className="absolute bottom-[-20%] right-[-10%] w-96 h-96 bg-pink-400/20 rounded-full blur-[120px]" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-900"
          >
            Ayrıcalık Sunan
            <span className="block text-transparent bg-clip-text bg-linear-to-r from-[#6320EE] to-[#DA38E2]">
              Anlaşmalı Markalar
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto"
          >
            Gyno Club dünyasında sana özel fırsatlar sunan seçkin markalarla tanış.
          </motion.p>
        </div>
      </section>


      <section className="relative z-10 max-w-7xl mx-auto px-6 pb-32">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            visible: {
              transition: { staggerChildren: 0.06 }
            }
          }}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6"
        >

          {brands.length > 0 && brands.map((brand, i) => {
            if (brand.brandLogo?.filename_disk) {
              return (
                <motion.div
                  key={i}
                  variants={{
                    hidden: { opacity: 0, y: 20 },
                    visible: { opacity: 1, y: 0 }
                  }}
                  whileHover={{ y: -6 }}
                  className="group relative rounded-2xl bg-white/70 backdrop-blur-xl border border-white/40 shadow-[0_10px_30px_rgba(0,0,0,0.05)] hover:shadow-[0_15px_40px_rgba(99,32,238,0.15)] transition-all duration-300"
                >
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300 bg-linear-to-br from-[#6320EE]/10 to-[#DA38E2]/10" />

                  <div className="relative flex items-center justify-center aspect-square p-6">
                    <Image
                      src={`https://api.gynoclub.com.tr/assets/${brand.brandLogo.filename_disk}`}
                      alt={brand.brandLogo.title}
                      fill
                      className="object-contain p-6 grayscale group-hover:grayscale-0 transition duration-300"
                    />
                  </div>
                </motion.div>
              )
            }
          })}
        </motion.div>
      </section>
    </main>
  )
}
